module.exports = __webpack_public_path__ + "static/privacy_shield-828bae922bcebe7c0e7ef7ff580d1b03.png";